import type { CSSProperties } from "react";
import clsx from "clsx";

interface SkeletonProps {
  className?: string;
  /** For widths that are not on Tailwind's scale, e.g. ragged lines of text. */
  style?: CSSProperties;
}

export function Skeleton({ className, style }: SkeletonProps) {
  return (
    <div
      className={clsx("animate-pulse rounded-md", "bg-card-muted", className)}
      style={style}
    />
  );
}
